import { render, staticRenderFns } from "./form-board-create-user.vue?vue&type=template&id=feec9906&"
import script from "./form-board-create-user.vue?vue&type=script&lang=js&"
export * from "./form-board-create-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports